import { FlowStepData } from "../FlowStepData";

export class RunFlow extends FlowStepData {
    readonly __type: string = "run_flow";

    constructor() {
        super();
        this.name = "Run Flow";
    }
}
